/**
 * Agenda-datums zijn YYYY-MM-DD zonder tijdzone en worden als NL-lokale dag
 * gelezen. Gedeeld door Agenda en Intervisie zodat "vandaag telt als komend"
 * en de maandlabels op beide pagina's hetzelfde blijven.
 */
export const MONTH_SHORT = [
  'jan',
  'feb',
  'mrt',
  'apr',
  'mei',
  'jun',
  'jul',
  'aug',
  'sep',
  'okt',
  'nov',
  'dec',
];
export const MONTH_ABBR = MONTH_SHORT.map((m) => m.toUpperCase());
export const WEEKDAYS = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
const WEEKDAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
const MAANDEN = [
  'januari',
  'februari',
  'maart',
  'april',
  'mei',
  'juni',
  'juli',
  'augustus',
  'september',
  'oktober',
  'november',
  'december',
];

/** Parse a YYYY-MM-DD date string into display parts (NL local, 0-indexed month). */
export function parseDate(date: string): {
  year: number;
  month: number;
  day: number;
  weekday: string;
} {
  const [year, month, day] = date.split('-').map(Number);
  const d = new Date(year!, month! - 1, day!);
  return { year: year!, month: month! - 1, day: day!, weekday: WEEKDAYS[d.getDay()]! };
}

/** "donderdag 10 september" */
export function langeDatum(date: string): string {
  const { year, month, day } = parseDate(date);
  return `${WEEKDAGEN[new Date(year, month, day).getDay()]} ${day} ${MAANDEN[month]}`;
}

export function isUpcoming(date: string): boolean {
  const { year, month, day } = parseDate(date);
  const today = new Date();
  return (
    new Date(year, month, day) >= new Date(today.getFullYear(), today.getMonth(), today.getDate())
  );
}
